import React from 'react';
import { Button } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';

const SlidingSideBar = ({
  children,
  visible = false,
  title = '',
  showCloseButton = true,
  onClose,
  fullScreen,
  zIndex = 1000,
  width,
  additionalHeaderContent
}) => {
  const Header = () => {
    return (
      <div className=" sticky-top bg-white p-2">
        <div className="d-flex">
          <h5 className="flex-grow-1">{title}</h5>
          {additionalHeaderContent}
          {showCloseButton && (
            <Button size="sm" className="close_button ml-2" onClick={onClose} variant="danger">
              Close <X size={20} className="align-text-top" />
            </Button>
          )}
        </div>
        <hr className="mt-2 mb-0" />
      </div>
    );
  };

  const contentStyle = width && !fullScreen ? { width: typeof width === 'number' ? `${width}%` : width } : {};

  return (
    <div style={{ zIndex: zIndex }} className={`bar-container ${visible ? 'bar-visible' : 'bar-collapsed'}`}>
      <div className={`bar-content${fullScreen ? '-fullscreen' : ''}`} style={contentStyle}>
        {(title || showCloseButton) && <Header />}
        <div id="bar-body">{children}</div>
      </div>
    </div>
  );
};

export default SlidingSideBar;
